<div class="equipo d-md-none d-flex flex-column gap-3">
  <div *ngFor="let persona of personas" class="persona-card d-flex align-items-end gap-3 pointer">
    <div class="imagen-contenedor">
      <img [src]="persona.imagen" alt="{{ persona.nombre }}" class="imagen" />
    </div>
    <div class="texto-contenedor text-start d-flex flex-column gap-1 pb-3 pe-3">
      <span class="nombre fw-bold">{{ persona.nombre }}</span>
      <div class="d-flex flex-column gap-1">
        <span class="cargo fs-8">{{ persona.cargo }}</span>
        <img src="assets/svg/linkdin-mobile.svg" class="linkedin-link" />
      </div>
    </div>
  </div>
</div>
